import React from "react";
import styles from "./MethodologySection.module.css";
import { scrollToSection, sectionIds } from "../utils/scroll";
import ArrowLinkButton from "./ArrowLinkButton";

const leftPrinciples = [
  {
    number: "01",
    title: "Agile Requirements Engineering",
    description:
      "Wir verstehen Anforderungen durch strukturierte Fragen tiefgreifend und übersetzen sie in klare, umsetzbare Spezifikationen.",
  },
  {
    number: "02",
    title: "Best-in-class Software-Architektur",
    description:
      "Starke Architekturgrundlagen sorgen für Skalierbarkeit, Qualität und belastbare technologische Entscheidungen.",
  },
];

const rightPrinciples = [
  {
    number: "03",
    title: "Agile Planung, Entwicklung und Tests",
    description:
      "Iterative Umsetzung ermöglicht schnelle Anpassung, frühes Feedback und kontinuierliche Verbesserung.",
  },
  {
    number: "04",
    title: "Quantitatives, metrikbasiertes QA-System",
    description:
      "Qualitätssicherung wird mit messbaren Kennzahlen und anerkannten Standards systematisch abgesichert.",
  },
  {
    number: "05",
    title: "Sichere und professionelle Bereitstellung und Betrieb",
    description:
      "Deployment und Betrieb werden auf Stabilität, Sicherheit und langfristige Zuverlässigkeit ausgerichtet.",
  },
];

function MethodologySection() {
  return (
    <section className={styles.section}>
      <div className={styles.topBar}>
        <p className={styles.label}>
          Unsere <span className="accent-underline">Philosophie</span>
        </p>
      </div>

      <div className={styles.layout}>
        <div className={styles.column}>
          <h2 className={styles.headline}>Unser einzigartiger Ansatz für Software</h2>
          <div className={styles.principles}>
            {leftPrinciples.map((principle) => (
              <article className={styles.principle} key={principle.number}>
                <div className={styles.principleHeader}>
                  <span className={styles.badge}>{principle.number}</span>
                  <h3 className={styles.principleTitle}>{principle.title}</h3>
                </div>
                <p className={styles.principleDescription}>
                  {principle.description}
                </p>
              </article>
            ))}
          </div>
        </div>

        <div className={styles.column}>
          <div className={styles.principles}>
            {rightPrinciples.map((principle) => (
              <article className={styles.principle} key={principle.number}>
                <div className={styles.principleHeader}>
                  <span className={styles.badge}>{principle.number}</span>
                  <h3 className={styles.principleTitle}>{principle.title}</h3>
                </div>
                <p className={styles.principleDescription}>
                  {principle.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.actionRow}>
        <ArrowLinkButton onClick={() => scrollToSection(sectionIds.contact)}>
          Mehr erfahren
        </ArrowLinkButton>
      </div>
    </section>
  );
}

export default MethodologySection;
